// The Nav uses basic bootstrap4 classes and methods to create the fixed Navbar
// Additional css has been used to customize the bootstrap elements
// The changing tabs with scroll effect is controlled by data-spy methods in index.html and requires all component contents to be 
    // contained in a "container-fluid" class

import React from "react";
import './Nav.css';


class Nav extends React.Component {

    render() {
        return (
          <nav className="navbar navbar-expand-sm bg-dark navbar-dark fixed-top">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="collapsibleNavbar">
                <ul className="navbar-nav">
                <li className="nav-item">
                        <a className="nav-link" href="#header">Home</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#services">Services</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#clients">Clients</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#contact-us">Contact Us</a>
                    </li>                    
                </ul>
                </div>
            </nav>

        );
    }
}
export default Nav;


